namespace RedBullMOBILE360.Sms {
    export class AddonColumns {
        static columnsKey = 'Sms.Addon';
    }
}